// extracted by mini-css-extract-plugin
module.exports = {"holder":"BillModuleDates_holder__5uGB3","billDate":"BillModuleDates_billDate__HI2IC"};